<template>
  <div>
    <mac_kucun_list  :caozuo_flag_props="3" > </mac_kucun_list> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import macKucunList from '../../tongyong/kucun.vue';
 
export default {

  components: {
    mac_kucun_list: macKucunList 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
